/** @format */
import { Injectable } from '@angular/core';
import { EntityState, EntityStore, QueryEntity, StoreConfig } from '@datorama/akita';
import { NgEntityServiceConfig } from '@datorama/akita-ng-entity-service';
import { OtmId, SignatureRequestBasicInfo } from 'common-typescript/types';
import { Observable, switchMap, tap } from 'rxjs';
import { EntityService } from './entity.service';

const CONFIG = {
    ENDPOINTS: {
        backend: '/seppo/api',
        findSignatureRequestBasicInfos() {
            return `${this.backend}/signature-request-basic-info`;
        },
        cancel(signatureRequestId: OtmId) {
            return `${this.backend}/cancel-signature-request/${signatureRequestId}`;
        },
    },
};
@Injectable({
    providedIn: 'root',
})
@NgEntityServiceConfig({
    baseUrl: CONFIG.ENDPOINTS.backend,
})
export class SignatureRequestBasicInfoEntityService extends EntityService<SignatureRequestBasicInfoState> {
    constructor() {
        super(SignatureRequestBasicInfoStore, SignatureRequestBasicInfoQuery);
    }

    findSignatureRequestBasicInfos(graduationId: OtmId): Observable<SignatureRequestBasicInfo[]> {
        const options = {
            params: {
                graduationId,
            },
        };
        return this.getHttp()
            .get<SignatureRequestBasicInfo[]>(CONFIG.ENDPOINTS.findSignatureRequestBasicInfos(), options)
            .pipe(
                tap(signatureRequests => this.store.upsertMany(signatureRequests)),
                switchMap(() => this.query.selectAll({ filterBy: entity => entity.graduationId === graduationId })),
            );
    }

    cancel(signatureRequestId: OtmId): Observable<SignatureRequestBasicInfo> {
        return this.getHttp()
            .put<SignatureRequestBasicInfo>(CONFIG.ENDPOINTS.cancel(signatureRequestId), {})
            .pipe(tap(signatureRequest => this.store.upsert(signatureRequest.id, signatureRequest)));
    }
}
type SignatureRequestBasicInfoState = EntityState<SignatureRequestBasicInfo, OtmId>;

@StoreConfig({ name: 'signature-request-basic-info' })
class SignatureRequestBasicInfoStore extends EntityStore<SignatureRequestBasicInfoState> {}

class SignatureRequestBasicInfoQuery extends QueryEntity<SignatureRequestBasicInfoState> {
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(store: SignatureRequestBasicInfoStore) {
        super(store);
    }
}
